/// <amd-module name="Wit/DeliveryPlans/PlanSettingsPanel/PlanSettingsConstants" />

import { CoreFieldRefNames } from "Wit/Common/Generated/Constants";
import { FieldSettingsConstants } from "Wit/Common/WitSettingsViews/Components/FieldSettingsConstants";
import * as Resources from "Wit/DeliveryPlans/Resources";

export namespace SettingsViewConstants {
    export const overview = Resources.OverviewSettingsTab;
    export const teams = Resources.TeamSettingsTab;
    export const fieldCriteria = Resources.FieldCriteriaSettingsTab;
    export const markers = Resources.MarkerSettingsTab;
    export const fields = Resources.FieldSettingsTab;
    export const styles = Resources.StylesSettingsTab;

    export const maxAdditionalFields = 10;
    export const maxMarkers = 30;
}

/**
 * List of setting views to display in the master detail panel
 */
export const settingsViews = [
    SettingsViewConstants.overview,
    SettingsViewConstants.teams,
    SettingsViewConstants.fieldCriteria,
    SettingsViewConstants.markers,
    SettingsViewConstants.fields,
    SettingsViewConstants.styles
];

export const DeliveryPlansExcludedAdditionalFields = new Set([
    ...FieldSettingsConstants.notSupportedFieldReferenceNames,
    CoreFieldRefNames.State.toLowerCase(),
    CoreFieldRefNames.Parent.toLowerCase()
]);
